/** @format */

import { FormLogin, FormLoginSocial, FormRegister, TypeVerify } from "types";
import { END_POINT } from "utils";
import axiosClient from "./axios";

export const authService = {
  refreshToken: async (rfToken: string) => {
    return await postRequest(END_POINT.AUTH.REFRESH_TOKEN, {
      refresh: rfToken,
    });
  },
  login: async (formData: FormLogin) => {
    return await postRequest(END_POINT.AUTH.LOGIN, formData);
  },
  loginGoogle: async (idToken: FormLoginSocial) => {
    return await postRequest(END_POINT.AUTH.LOGIN_SOCIAL, idToken);
  },
  register: async (formData: FormRegister) => {
    return await postRequest(END_POINT.AUTH.REGISTER, formData);
  },

  verifyEmail: async (email: string, mode: TypeVerify) => {
    const url = `${END_POINT.AUTH.VERIFY_EMAIL}?email=${email}&mode=${mode}`;
    const data = await axiosClient.get(url);
    return data?.data;
  },
  verifyOtp: async (email: string, type: string, code: string) => {
    const url = `${END_POINT.AUTH.VERIFY_OTP}?email=${email}&type=${type}&code=${code}`;
    const data = await axiosClient.get(url);
    return data?.data;
  },
  changePassword: async (formData: { uid: string; newPassword: string }) => {
    return await postRequest(END_POINT.AUTH.CHANGE_PASSWORD, {
      uid: formData.uid,
      newPassword: formData.newPassword,
    });
  },
};

const postRequest = (url: string, param: any) => axiosClient.post(url, param);
